import { isObject } from './isObject';

/**
 * @module validator.object
 */

/**
 * If argument is not `Object`, it will throw error.
 */
export function isObjectEmpty(arg: object): boolean {
	if (!isObject(arg)) {
		throw new Error('arg should be object.');
	}

	return Object.keys(arg).length === 0;
}
